import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import classes from "./Auth.module.css";
import { Link } from "react-router-dom";
import { authResetPassword } from "../../network/auth";
import { useMutation } from "@tanstack/react-query";
import cogoToast from "cogo-toast";
import { Form, Input, Button } from "antd";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const { mutate: onResetPassword, isPending } = useMutation({
    mutationFn: (formData) => authResetPassword(formData),
    onSuccess: (data) => {
      cogoToast.success(data.message);
      form.resetFields();
    },
    onError: () => {
      cogoToast.warn(t("auth.errorMessage"), { position: "top-right" });
    },
  });

  const onFinish = (values) => {
    onResetPassword(values);
  };

  return (
    <Container>
      <Row>
        <Col className="mx-auto py-5" xl={8} lg={8} md={8} sm={12}>
          <h4 className={`${classes["auth-header-title"]}`}>
            Reset Password.
          </h4>
          <h6 className={`${classes["auth-subheader-title"]}`}>
            Already member?{" "}
            <Link to="/login" className={`${classes["register-link"]}`}>
              Login
            </Link>{" "}
            here.
          </h6>

          <Card className={`${classes["custom-card"]}`}>
            <Card.Body>
              <Row>
                <Col></Col>
                <Col xl={8}>
                  <Form
                    required={false}
                    form={form}
                    name="resetPassword"
                    onFinish={onFinish}
                    layout="vertical"
                  >
                    <Form.Item
                      required={false}
                      name="password"
                      label={t("auth.newPassword")}
                      rules={[
                        { required: true, message: t("auth.newPasswordValidationRequired") },
                      ]}
                    >
                      <Input.Password placeholder={t("auth.newPasswordPlaceholder")} />
                    </Form.Item>
                    <Form.Item
                      required={false}
                      name="confirm"
                      dependencies={['password']}
                      label={t("auth.reEnterNewPasswordPlaceholder")}
                      rules={[
                        { required: true, message: t("auth.reEnterNewPasswordValidationRequired") },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(t("auth.notMatchPassword")));
                          },
                        }),
                      ]}
                    >
                      <Input.Password placeholder={t("auth.reEnterNewPasswordPlaceholder")} />
                    </Form.Item>

                    <Button loading={isPending} type="primary" htmlType="submit"  className={`${classes["auth-button"]}`}>
                      {t("auth.resetPassword")}
                    </Button>
                  </Form>
                </Col>
                <Col></Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}


export default ResetPassword;
